import { backendDelete, backendFetch } from '@/common/api';
import { SessionData } from 'react-router-dom';
import * as Sentry from '@sentry/react';

export async function fetchSession(): Promise<SessionData> {
  return backendFetch('/portal/session', { credentials: 'include' });
}

export async function logout(): Promise<void> {
  await backendDelete('/portal/session', { credentials: 'include' });

  // Clear Sentry user context on logout
  Sentry.setUser(null);
}
